import { render, staticRenderFns } from "./FormRekonShipper.vue?vue&type=template&id=13e84e67&scoped=true"
import script from "./FormRekonShipper.vue?vue&type=script&lang=js"
export * from "./FormRekonShipper.vue?vue&type=script&lang=js"
import style0 from "./FormRekonShipper.vue?vue&type=style&index=0&id=13e84e67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e84e67",
  null
  
)

export default component.exports